import React from "react";

export const WarningIcon = (props:React.SVGProps<SVGSVGElement> & {size?:number|string}) => (
  <svg {...props} className={props.className} width={props.size || 30} height={props.size || 30} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M40 40H10a4 4 0 0 1-3.4-6l15-25.2a4 4 0 0 1 6.8 0l15 25.2a4 4 0 0 1-3.4 6z" stroke="CurrentColor" strokeWidth="1.5"/><circle cx="25" cy="33.5" r="1.5" fill="CurrentColor"/><path d="M25 13.5v13" stroke="CurrentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);